"use client";
import {
  Documentation,
  DocumentationApiCategoryType,
} from "@/lib/types/documentation.ts";
import * as S from "./styles.ts";
import { UniversalLink } from "@template/components";
import { Commands } from "./Commands";

interface IDocsTemplateSectionComponentProps {
  documentation: Documentation;
  parentCategory: string;
  category: DocumentationApiCategoryType;
}

const Breadcrumb = ({ route }) => (
  <S.Breadcrumb data-is-last={!route.child}>
    <UniversalLink href={route.link}>{route.title}</UniversalLink>
    {route.child && (
      <>
        <span>{"/"}</span>
        <Breadcrumb route={route.child} />
      </>
    )}
  </S.Breadcrumb>
);

const Breadcrumbs = ({ route }) => {
  return (
    <S.BreadcrumbsContainer>
      <Breadcrumb route={route} />
    </S.BreadcrumbsContainer>
  );
};

const capitalise = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

const DocsTemplateSectionComponent = ({
                                        documentation,
                                        category,
                                        parentCategory,
                                      }: IDocsTemplateSectionComponentProps) => {
  const { name, description, commands } = documentation;
  const isDomains = category === "domain-names";

  const route = {
    title: "API Documentation",
    link: `${isDomains ? "/domain-names" : "/voip"}/api-docs`,
    child: {
      title: capitalise(parentCategory),
      link: `${
        isDomains ? "/domain-names" : "/voip"
      }/api-docs/${parentCategory}/${documentation.key}`,
      child: {
        title: documentation.name,
        link: `${
          isDomains ? "/domain-names" : "/voip"
        }/api-docs/${parentCategory}/${documentation.key}`,
      },
    },
  };
  return (
    <S.DocsTemplateSectionWrapper>
      <S.DocsTemplateSectionContainer>
        <Breadcrumbs route={route} />
        <S.Title> {name}</S.Title>
        <S.Description> {description}</S.Description>
        <Commands commands={commands} />
      </S.DocsTemplateSectionContainer>
    </S.DocsTemplateSectionWrapper>
  );
};

export default DocsTemplateSectionComponent;
export const options = [
  {
    description: "",
    displayName: "DocsTemplateSectionComponent",
    methods: [],
    props: {
      documentation: {
        required: true,
        flowType: { name: "Documentation" },
        description: "",
      },
      parentCategory: {
        required: true,
        flowType: { name: "string" },
        description: "",
      },
      category: {
        required: true,
        flowType: { name: "DocumentationApiCategoryType" },
        description: "",
      },
    },
  },
];
